import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest, select } from "redux-saga/effects";
import { getUserByToken } from "./authCrud";
import cogoToast from 'cogo-toast';
import { errorMessage } from "../../../util/Helpers";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  sessionUpdated: "[Session Update] Action"
};

export const initialAuthState = {
  user: undefined,
  authToken: undefined,
  session: {
      active: false, 
      expire: (new Date()).getTime(),
      validity: +(process.env.REACT_APP_SESSION_VALIDITY ?? "30")
    }
};

/**
 * Redux reducer
 */

export const reducer = persistReducer(
  { storage, key: "oversight-dashboard", whitelist: ["user", "authToken", "session"] },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const {authToken}  = action.payload;
        const currDate = new Date();
        currDate.setMinutes(currDate.getMinutes() + state.session.validity);
        const session = {...state.session, active: true, expire: currDate.getTime()};
        return { authToken, user: undefined, session };
      }

      case actionTypes.Register: {
        const { authToken } = action.payload;

        return { authToken, user: undefined };
      }

      case actionTypes.UserLoaded: {
        const { user } = action.payload;
        return { ...state, user };
      }

      case actionTypes.sessionUpdated: {
        const { authToken, session } = action.payload;
        return { ...state, authToken, session };
      }

      default:
        return state;
    }
  }
);

/**
 * User Auth actions
 */
export const actions = {
  login: (authToken, history) => ({ type: actionTypes.Login, payload: { authToken, history } }),
  register: (authToken) => ({
    type: actionTypes.Register,
    payload: { authToken },
  }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: (history) => ({
    type: actionTypes.UserRequested,
    payload: { history },
  }),
  fulfillUser: (user, history) => ({ type: actionTypes.UserLoaded, payload: { user, history } }),
  updateSession: (authToken, session) => ({ type: actionTypes.sessionUpdated, payload: { authToken, session } })

};

/**
 * Saga Authentication Middlewares
 */

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga({payload:{history}}) {
    yield put(actions.requestUser(history));
  });

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.UserRequested, function* userRequested({payload:{history}}) {
    try{
      const { data: user } = yield getUserByToken();
      yield put(actions.fulfillUser(user, history));
    }
    catch(err){
      history.push("/overview");   // Reload Login Page
      cogoToast.error(errorMessage(err))
    }
  });

  yield takeLatest(actionTypes.UserLoaded, function* userLoaded({payload}) {
    const user = yield select(state => state.auth.user);
    if (user && !user.otpSatisfied){
      /* Redirect to otp input page */
      yield payload.history.push("/2fa-otp");
    }
  });
}
